module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Action Type"},"no":{"title":"Tiltakstype"}}')
  delete Component.options._Ctor
}
